import { forwardRef, useEffect, useState } from "react";
import iconCalendar from "src/assets/img/calendarIcon.png";
import { XIconDesktop, XIconMobile } from "src/components/UI/Icon/XIcon";
import { useDeviceContext } from "src/context/device-context";
import { useTenantContext } from "src/context/tenant-context";
import { getDisplayDateValue } from "src/utils/date-utils";
import classes from "./SearchFormDate.module.css";

const SearchFormDate = forwardRef(function SearchFormDate(
  { id, value, label, onClick, className, onClear, icon: Icon },
  ref,
) {
  const { isMobile } = useDeviceContext();
  const { dateFormat } = useTenantContext();
  const [hasInput, setHasInput] = useState(!!value);

  const onClickIcon = (e) => {
    e.stopPropagation();
    onClear(id);
  };

  useEffect(() => {
    setHasInput(!!value);
  }, [value]);

  return (
    <label
      ref={(r) => {
        if (ref) {
          ref[id] = r;
        }
      }}
      htmlFor={id}
      className={`${classes.frame} ${className ?? ""} ${Icon ? classes.hasIcon : ""} frame-sf-field`}
      onClick={onClick}>
      {Icon && <Icon size={18} stroke={1.75} className={classes.leftIcon} />}
      <span
        className={
          hasInput
            ? onClick
              ? classes.smallText
              : `${classes.smallText} ${classes.datePicker}`
            : classes.bigText
        }>
        {label}
      </span>
      <input
        id={id}
        type="text"
        readOnly
        value={getDisplayDateValue(value, dateFormat)}
        onKeyDown={(e) => e.key === "Enter" && onClick(e)}
        hidden={!value}
      />

      {hasInput && onClear ? (
        <button
          type="button"
          aria-label="Clear date"
          data-testid={`${id}-clear-date`}
          className={classes.icon}
          onClick={onClickIcon}>
          {isMobile ? <XIconMobile /> : <XIconDesktop />}
        </button>
      ) : (
        <button
          type="button"
          aria-label="Open calendar"
          data-testid={`${id}-open-calendar`}
          className={classes.icon}>
          <img alt="" width={20} src={iconCalendar} />
        </button>
      )}
    </label>
  );
});

export default SearchFormDate;
